module.exports = __webpack_public_path__ + "static/img/01.487b523.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/junActivitySpecialty2/01.png
// module id = 4gGD
// module chunks = 0